import { OrderCurrency } from '@invenco/common-interface/sales';

export const DEFAULT_PAGE_TITLE = 'Lynk';

export const DEFAULT_TIME_ZONE = 'Australia/Sydney';
export const DEFAULT_DATE_FORMAT = 'MMM d, yyyy';
export const DEFAULT_DATETIME_FORMAT = 'MMM d, yyyy, h:mm aaa';
export const DEFAULT_TIME_FORMAT = 'h:mm aaa';

export const DEFAULT_PAGE_SIZE = 50;
export const MAX_AUTO_COMPLETE_RESULTS = 50;
export const DEFAULT_USER_ACCOUNT_LIST_SIZE = 9;

export const DEBOUNCE_TIMEOUT_MS = 250;
export const LIVE_DATA_INTERVAL_MS = 3000;
export const DATA_POLLING_DURATION_MS = 10000;

export const MENU_COLLAPSED_STORAGE_KEY = 'lynk/menu-collapsed';

export const SUPPORTED_CURRENCIES = [
  OrderCurrency.AUD,
  OrderCurrency.USD,
  OrderCurrency.GBP,
  OrderCurrency.CAD,
  OrderCurrency.NZD,
  OrderCurrency.EUR,
  OrderCurrency.HUF,
  OrderCurrency.SAR,
  OrderCurrency.AED,
  OrderCurrency.JPY,
  OrderCurrency.SGD,
  OrderCurrency.THB,
  OrderCurrency.MYR,
] as const;

export const MAX_TAG_CHARACTERS = 40;

export const NA_TEXT = 'N/A';
export const EMPTY_TEXT_VALUE = '\u2014';

// for use with list views for tables which support saving views
// these values will be used to populate listId and associate saved views with the table
export const TABLE_IDS = [
  'asns',
  'orders',
  'inventoryQuantities',
  'skus',
  'listings',
  'workflows',
] as const;

export type TableId = (typeof TABLE_IDS)[number];

export const NEW_UI_DOCUMENT_CLASS = 'mcshadwind';
